import taiNgheLenovoTh10 from "../static/img/affiliate/tai-nghe-lenovo-th10.jpg";
import chuotLogitechB100 from "../static/img/affiliate/chuot-logitech-b100.jpg";
import sachSapiens from "../static/img/affiliate/sach-sapiens.jpg";
import bongTayTrangCotton from "../static/img/affiliate/bong-tay-trang-cotton.jpg";

export type AffiliateCategory = "focus" | "desk" | "book" | "care";

export type AffiliateVendor = "shopee";

export interface AffiliateProduct {
  /** Slug ổn định — dùng làm GA4 param. Không bao giờ tái sử dụng cho sản phẩm khác. */
  id: string;
  name: string;
  /** Một dòng rút từ mô tả gốc của shop. */
  shortPitch: string;
  /**
   * Nhận xét thật của admin, giữ nguyên văn kể cả nhược điểm — đây là thứ
   * phân biệt đơn vị này với quảng cáo và là lý do người dùng tin.
   */
  adminNote: string[];
  /** Ghi chú ai là người nhận xét, khi không phải chính admin. */
  noteAttribution?: string;
  /** Luôn kèm "≈" vì đây không phải giá realtime. */
  priceRange?: string;
  category: AffiliateCategory;
  /** Link tiếp thị liên kết. Không bao giờ mở link này từ máy dev (Shopee tính là self-click). */
  url: string;
  vendor: AffiliateVendor;
  image?: string;
  imageAlt?: string;
  badge?: string;
  priority?: number;
  /** Đặt false để tắt ngay một sản phẩm khi link hết hạn. */
  active?: boolean;
  /** Mốc kiểm tra link gần nhất — audit hàng quý. */
  checkedAt?: string;
}

export const AFFILIATE_PRODUCTS: AffiliateProduct[] = [
  {
    id: "tai-nghe-lenovo-th10",
    name: "Tai nghe Lenovo ThinkPlus TH10",
    shortPitch:
      "Tai nghe chụp tai, driver 40mm, dùng được cả Bluetooth 5.0 lẫn dây 3.5mm, pin 8 giờ.",
    adminNote: [
      "Mình dùng chính con tai nghe này để ôn thi TOEIC để ra trường.",
      "Rẻ, nghe ổn, nghe nhạc tạm ổn.",
      "Mùa hè đeo hơi nóng, trong phòng điều hòa thì oke.",
      "Pin trâu.",
      "Kết nối bluetooth tốt, có khả năng kết nối nhiều thiết bị cùng lúc.",
      "Dùng được cả bluetooth và dây.",
    ],
    category: "focus",
    url: "https://s.shopee.vn/7ps28TKLP3",
    vendor: "shopee",
    image: taiNgheLenovoTh10,
    imageAlt: "Tai nghe Lenovo ThinkPlus TH10",
    badge: "Mình ôn TOEIC bằng con này",
    priority: 10,
    active: true,
    checkedAt: "2026-07-29",
  },
  {
    id: "chuot-logitech-b100",
    name: "Chuột có dây Logitech B100",
    shortPitch:
      "Chuột quang có dây 800 DPI, cắm là chạy, thuận cả hai tay, bảo hành 3 năm.",
    adminNote: [
      "Mình không thích dùng chuột không dây vì kém nhạy và hay phải thay pin (mình không có tiền để mua mấy loại có pin sạc).",
      "Mình trung thành với chuột B100 đã được 5 năm, từ hồi còn là sinh viên.",
      "Nhu cầu của mình rất cơ bản, mình không chơi game nên không cần chuột quá nhạy.",
      "Chuột rất bền và rất tiện, với mình là không có nhược điểm.",
    ],
    category: "desk",
    url: "https://s.shopee.vn/AUsnK3J8yB",
    vendor: "shopee",
    image: chuotLogitechB100,
    imageAlt: "Chuột có dây Logitech B100 màu đen",
    badge: "Mình dùng 5 năm",
    priority: 10,
    active: true,
    checkedAt: "2026-07-29",
  },
  {
    id: "sach-sapiens",
    name: "Sapiens: Lược Sử Loài Người",
    shortPitch:
      "Yuval Noah Harari — NXB Tri Thức, bìa mềm, 554 trang. Dịch giả Nguyễn Thủy Chung.",
    adminNote: [
      "Cuốn sách mình đọc từ thời còn là sinh viên, giúp mình mở mang vốn sống.",
      "Nếu có ai hỏi cuốn sách nên đọc đầu tiên, mình sẽ gợi ý cuốn này.",
      "Cuốn sách không quá lịch sử, không quá khoa học, không quá triết lý, nhưng lại đủ cân bằng để giúp mình hiểu biết hơn về vị trí của bản thân trong cuộc sống này.",
    ],
    category: "book",
    url: "https://s.shopee.vn/7fYbx3KtiI",
    vendor: "shopee",
    image: sachSapiens,
    imageAlt: "Bìa sách Sapiens: Lược Sử Loài Người",
    badge: "Cuốn mình gợi ý đọc đầu tiên",
    priority: 10,
    active: true,
    checkedAt: "2026-07-29",
  },
  {
    id: "bong-tay-trang-cotton",
    name: "Bông tẩy trang cotton 222 miếng",
    shortPitch:
      "100% cotton, miếng tròn 2 mặt, túi zip 222 miếng chống bụi.",
    noteAttribution:
      "Admin Grade PTIT là nam nên mấy thứ này không rành lắm — đây là nhận xét của vợ mình.",
    adminNote: [
      "Giá rẻ, dùng ổn, thấm hút tốt, bông tẩy trang dùng được cả 2 mặt.",
      "Số lượng 1 túi nhiều.",
      "Nếu mặt không trang điểm khoảng 4 bông là sạch, còn trang điểm thì 7-8 bông.",
    ],
    category: "care",
    url: "https://s.shopee.vn/3Vj2vCmm2N",
    vendor: "shopee",
    image: bongTayTrangCotton,
    imageAlt: "Túi bông tẩy trang cotton 222 miếng",
    badge: "Vợ mình recommend",
    priority: 10,
    active: true,
    checkedAt: "2026-07-29",
  },
];

export const getActiveProducts = (): AffiliateProduct[] =>
  AFFILIATE_PRODUCTS.filter((product) => product.active !== false);

export const getProductById = (id: string): AffiliateProduct | undefined =>
  AFFILIATE_PRODUCTS.find((product) => product.id === id);
